import { useNuxtApp, useRuntimeConfig } from '#imports'

export default defineNuxtPlugin({
  name: 'enterprise-extra-client-script-runtime',
  dependsOn: ['enterprise'],
  setup() {
    if (!true) return

    if (!window.__grouper) return

    const nuxtApp = useNuxtApp()
    const runtimeConfig = useRuntimeConfig()
    const queuedHooks = window.__grouper._queuedHooks || []

    window.__grouper = {
      ...window.__grouper,
      $router: nuxtApp.$router,
      config: runtimeConfig.public,
      hook: (name, fn) => nuxtApp.hook(name, fn),
    }

    for (const [name, fn] of queuedHooks) {
      nuxtApp.hook(name, fn)
    }

    delete window.__grouper._queuedHooks
  },
})
